var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"price-trend-container"},[_c('div',{ref:"chart",staticClass:"chart-wrapper"})])
}
var staticRenderFns = []

export { render, staticRenderFns }